import { persistReducer } from "redux-persist";

export function persistReducerGenerator(persistConfig, reducer) {
    return persistReducer(persistConfig, reducer);
}